export default __webpack_public_path__ + "static/media/order-up.57e9577e.svg";